var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMoon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  d: "M18.215 12.925a.627.627 0 0 0-.667-.183c-2.55.85-5.358-.075-6.841-2.259-1.584-2.333-1.259-5.5.758-7.541a.628.628 0 0 0-.442-1.067C6.54 1.875 2.898 5.517 2.898 10c0 4.483 3.642 8.125 8.125 8.125a8.09 8.09 0 0 0 7.284-4.517.638.638 0 0 0-.092-.691v.008Zm-7.192 3.95A6.882 6.882 0 0 1 4.148 10c0-3.308 2.35-6.075 5.459-6.725-1.534 2.4-1.559 5.517.066 7.917 1.5 2.216 4.125 3.358 6.75 3.075a6.829 6.829 0 0 1-5.4 2.616v-.008Z"
})));
export default SvgIconMoon;